import { GROUP_CLASS_MAX_ATTENDEES_LIMIT } from '../util/classes/groupClasses.util';

export const useGroupClassAttendeesLimit = (
  maximumAttendees: number,
): {
  isValidMaximumGroupClassAttendees: boolean;
  groupClassMaxAttendeesLimit: number;
} => {
  const groupClassMaxAttendeesLimit = GROUP_CLASS_MAX_ATTENDEES_LIMIT;
  const isValidMaximumGroupClassAttendees =
    Number.isInteger(maximumAttendees) &&
    maximumAttendees >= 1 &&
    maximumAttendees <= groupClassMaxAttendeesLimit;

  return {
    groupClassMaxAttendeesLimit,
    isValidMaximumGroupClassAttendees,
  };
};
